/**
 *
 * Exercise
 *
 */

import { delay, findIndex } from 'lodash';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import Swal from 'sweetalert2';
import Chart from 'chart.js';
import $ from 'jquery';

import WayFindBar from '@/components/WayFindBar.vue';
import ToolBar from '@/components/ToolBar.vue';
import Footer from '@/components/Footer.vue';
import Question from '@/components/Question/Question.vue';
import Spinner from '@/components/Spinner.vue';
import BookListMasterAchieved from '@/components/BookListMasterAchieved.vue';
import CourseLevelUp from '@/components/CourseLevelUp.vue';
import { EXERCISE_TITLE } from './Exercise.constants';
import { getLevelText, triggerShoolPride } from '../../utils';

export default {
  name: 'Exercise',
  components: {
    WayFindBar,
    ToolBar,
    Footer,
    Question,
    Spinner,
    CourseLevelUp,
    BookListMasterAchieved,
  },

  data: () => {
    return {
      currentType: -1,
      isShowQuestion: false,
      exerciseTitle: '',
      source: '',
      isShowBookListMasterAchieved: false,
      isShowCourseLevelUp: false,
      promiseGetCourseAnalysis: null,
      chartDoughnut: null,
    };
  },

  computed: {
    ...mapState({
      ms_isDebug: 'isDebug',
    }),

    ...mapGetters({
      isRequest: 'Exercise/isRequest',
      QuestionList: 'Exercise/QuestionList',
      Question: 'Exercise/Question',
      FirstFilterList: 'Exercise/FirstFilterList',
      typeQuestionList4mycollection: 'Exercise/typeQuestionList4mycollection',
      mywrongCountList: 'Exercise/mywrongCountList',
      CourseAnalysis: 'Exercise/CourseAnalysis',
      PzFilterData: 'Exercise/PzFilterData',
      AfterExerciseData: 'Exercise/AfterExerciseData',
      isBookLevelUp: 'Exercise/isBookLevelUp',
      isCourseLevelUp: 'Exercise/isCourseLevelUp',
      bookLevelUpTo: 'Exercise/bookLevelUpTo',
      courseLevelUpTo: 'Exercise/courseLevelUpTo',
      books: 'Exercise/books',
      BookList: 'Exercise/BookList',
    }),

    courseId: function () {
      return Number.parseInt(this.$route.params.courseId);
    },

    c_currentType() {
      if (108 === this.currentType) {
        return 8;
      } else {
        return this.currentType;
      }
    },

    c_isHasAfter() {
      return 108 !== this.currentType;
    },
  },

  created() {
    this.getCourseAnalysisData();
  },

  methods: {
    ...mapMutations('Exercise', {
      mm_SAVE_QUESTION_RANGY_MARK: 'SAVE_QUESTION_RANGY_MARK',
    }),

    ...mapActions({
      getQuestionList: 'Exercise/getQuestionList',
      getQuestionListType: 'Exercise/getQuestionListType',
      answer: 'Exercise/answer',
      noteSaved: 'Exercise/noteSaved',
      getQuestion: 'Exercise/getQuestion',
      getFirstFilterList: 'Exercise/getFirstFilterList',
      getPzFilterData: 'Exercise/getPzFilterData',
      getPzFilterDataType: 'Exercise/getPzFilterDataType',
      markQuestion: 'Exercise/markQuestion',
      getCourseAnalysis: 'Exercise/getCourseAnalysis',
      getAfterExerciseData: 'Exercise/getAfterExerciseData',
      removeWrongList: 'Exercise/removeWrongList',
    }),

    ...mapActions('Exercise', {
      ma_updateQuestionHtml: 'updateQuestionHtml',
    }),

    async getCourseAnalysisData() {
      this.promiseGetCourseAnalysis = this.getCourseAnalysis(this.courseId);
      await this.promiseGetCourseAnalysis;
      $(function () {
        $('[data-toggle="popover"]').popover();
      });
      const ctx = document.getElementById('pzChart');
      this.chartDoughnut = new Chart(ctx, {
        type: 'doughnut',
        data: {
          datasets: [
            {
              data: [
                this.CourseAnalysis.countLevel0,
                this.CourseAnalysis.countLevel1,
                this.CourseAnalysis.countLevel2,
                this.CourseAnalysis.countLevel3,
                this.CourseAnalysis.countLevel4,
              ],
              backgroundColor: ['#EBEDF0', '#E5B3FF', '#D480FF', '#AA00FF', '#7C00BA'],
            },
          ],
          labels: ['未开始', '练习中', '初步了解', '熟悉', '精通'],
        },
        options: {
          Axes: {
            display: false,
          },
          tooltips: {
            enabled: false,
          },

          responsive: true,
          legend: {
            display: false,
            position: 'top',
          },
          cutoutPercentage: 80,
          title: {
            display: false,
            text: 'Chart.js Doughnut Chart',
          },
          animation: {
            animateScale: true,
            animateRotate: true,
          },
        },
      });
    },

    updateDoughnutChart() {
      this.chartDoughnut.data.datasets[0].data = [
        this.CourseAnalysis.countLevel0,
        this.CourseAnalysis.countLevel1,
        this.CourseAnalysis.countLevel2,
        this.CourseAnalysis.countLevel3,
        this.CourseAnalysis.countLevel4,
      ];
      this.chartDoughnut.update();
    },

    goBack() {
      this.$router.go(-1);
    },

    go2BookPage({ courseId, bookId, readingId }, selector) {
      if (this.CourseAnalysis.isCertificateCourses) {
        $(selector).popover('hide');
        this.$router.push({ path: `/course/${courseId}/book/${bookId}/reading/${readingId}` });
      }
    },

    async go2Exercise(type) {
      if (!this.CourseAnalysis.hasQuestionLib) {
        Swal.fire({
          backdrop: true,
          icon: 'warning',
          width: '400px',
          title: `请到商城购买题库练习`,
          showConfirmButton: true,
        });
        return false;
      }
      this.currentType = type;
      this.isShowQuestion = true;
      if (type == -1) {
        this.exerciseTitle = '查题';
      } else {
        this.exerciseTitle = EXERCISE_TITLE[type - 1];
      }

      if (type === 1 || type === 4 || type === 7 || type === -1) {
        this.getQuestionList({
          practiceType: type,
          courseId: type == -1 ? type : this.courseId,
          bookId: -1,
          readingId: -1,
          attribute: [],
          source: this.source.trim(),
          questionOrder: true,
        });
      } else if (type === 8) {
        await this.getPzFilterData({
          courseId: this.courseId,
        });
        const payload = {
          practiceType: type,
          courseId: this.courseId,
          bookId: -1,
          readingId: -1,
          attribute: [],
        };
        await this.getQuestionList({
          ...payload,
          ...this.PzFilterData.studentFilter,
          questionOrder: true,
        });
      } else if (type === 108) {
        await this.getPzFilterDataType({
          courseId: this.courseId,
          type: 5,
        });
        if (this.PzFilterData.bookTreeList.length) {
          let payload = {
            practiceType: type,
            courseId: this.courseId,
            bookId: -1,
            readingId: -1,
            attribute: [],
          };
          payload = {
            ...payload,
            ...this.PzFilterData.studentFilter,
            practiceType: this.c_currentType,
            bookId: this.PzFilterData.bookTreeList[0].bookId,
            questionOrder: true,
            type: 5,
          };
          await this.getQuestionListType(payload);
        }
      } else {
        this.getFirstFilterList({
          courseId: this.courseId,
          exerciseType: type,
        });
      }
    },

    getQuestions(payload) {
      this.$store.commit('Exercise/GET_FIRST_FILTER_LIST_SUCCESS', []);
      let _payload = {
        practiceType: payload.practiceType,
        courseId: this.courseId,
        bookId: payload.bookId,
        readingId: payload.readingId,
        bulletId: payload.bulletId,
        subjectId: payload.subjectId,
        wrongCount: payload.wrongCount,
        random: payload.random,
        limit: payload.limit,
        attribute: payload.attribute,
        inFilter: payload.inFilter ? payload.inFilter : false,
      };
      if (108 !== this.currentType) {
        this.getQuestionList({
          ..._payload,
          questionOrder: true,
        });
      } else {
        _payload = {
          ..._payload,
          practiceType: this.c_currentType,
          bookId: this.PzFilterData.bookTreeList[0].bookId,
          questionOrder: true,
          type: 5,
        };
        this.getQuestionListType(_payload);
      }
    },

    closeQuestion() {
      this.isShowQuestion = false;
      if (this.isCourseLevelUp) {
        this.isShowCourseLevelUp = true;
        triggerShoolPride();
        this.resetCourseLevelUpStatus();
        return;
      } else if (this.isBookLevelUp) {
        this.isShowBookListMasterAchieved = true;
        triggerShoolPride();
        this.resetBookLevelUpStatus();
        return;
      } else {
        this.clearData();
      }
    },

    clearData() {
      this.$store.commit('Exercise/GET_QUESTION_LIST_SUCCESS', []);
      this.$store.commit('Exercise/GET_QUESTION_SUCCESS', {});
      this.$store.commit('Exercise/GET_FIRST_FILTER_LIST_SUCCESS', []);
      this.$store.commit('Exercise/GET_AFTER_EXERCISE_SUCCESS', {});
      this.$store.commit('Exercise/GET_PZ_FILTER_DATA_SUCCESS', {});
    },

    setQuestion(payload) {
      this.$store.commit('Exercise/SET_QUESTION', payload);
    },

    doAnswer(payload) {
      this.answer({ ...payload, courseId: Number.parseInt(this.courseId) });
    },

    async goToQuestion(questionId) {
      await this.getQuestion({ courseId: Number.parseInt(this.courseId), questionId });
    },

    async updateQuestionHtml() {
      await this.ma_updateQuestionHtml({
        courseId: Number.parseInt(this.courseId),
        questionId: this.Question.questionId,
      });
    },

    saveQuestionRangyMark(payload) {
      this.mm_SAVE_QUESTION_RANGY_MARK(payload);
    },

    async mark() {
      await this.markQuestion({
        courseId: Number.parseInt(this.courseId),
      });
      if (this.Question.qType !== 'xl') {
        Swal.fire({
          backdrop: false,
          icon: 'success',
          width: '400px',
          title: `${this.Question.isMarked ? '收藏成功' : '已取消收藏'}`,
          showConfirmButton: false,
          timer: 800,
        });
      } else {
        Swal.fire({
          backdrop: false,
          icon: 'success',
          width: '400px',
          title: `${this.Question.subQuestions[this.Question.pos].isMarked ? '收藏成功' : '已取消收藏'
            }`,
          showConfirmButton: false,
          timer: 800,
        });
      }
    },

    getText(level) {
      return getLevelText(level);
    },

    tempBookListToMaster() {
      this.isShowBookListMasterAchieved = true;
      triggerShoolPride();
    },

    closeBookListMasterAchieved() {
      this.isShowBookListMasterAchieved = false;
      this.clearData();
      this.$store.commit('Exercise/SET_BOOK_LEVEL_UP_STATUS', false);
    },

    closeCourseLevelUp() {
      this.isShowCourseLevelUp = false;
      this.clearData();
      this.$store.commit('Exercise/SET_COURSE_LEVEL_UP_STATUS', false);
    },

    goBackToCourse() {
      this.$nextTick(() => {
        this.closeCourseLevelUp();
        this.$router.push(`/course/${this.courseId}`);
      });
    },

    resetBookLevelUpStatus() {
      delay(() => {
        this.$store.commit('Exercise/SET_BOOK_LEVEL_UP_STATUS', false);
      }, 3000);
    },

    resetCourseLevelUpStatus() {
      delay(() => {
        this.$store.commit('Exercise/SET_COURSE_LEVEL_UP_STATUS', false);
      }, 3000);
    },

    async removeQuestionFromList() {
      const index = findIndex(this.QuestionList, {
        questionId: this.Question.questionId,
      });
      const nextQuestion = this.QuestionList[index + 1];
      const questionId = this.Question.questionId;
      await this.removeWrongList({ courseId: this.courseId, questionId });
      if (nextQuestion) {
        if (nextQuestion) {
          await this.goToQuestion(nextQuestion.questionId);
        }
      }
    },
    go2DemoMock() {
      $('#demoMockModal').modal('hide');
      if (this.CourseAnalysis.mallCategory.indexOf('cpa') != -1) {
        window.open(`https://cpa-online-exam.pzacademy.com/landing/${this.courseId}/2`, '_blank');
      } else {
        window.open(`https://online-exam.pzacademy.com/entry/${this.courseId}/2`, '_blank');
      }
    },
    open2DemoMock() {
      $('#demoMockModal').modal('show');
      // Swal.fire({
      //   title: '机考体验模式',
      //   text: `我是描述我是描述我是描述我是描述我是描述我是描述`,
      //   icon: 'info',
      //   showCancelButton: true,
      //   confirmButtonColor: '#3085d6',
      //   cancelButtonColor: '#d33',
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      // }).then((result) => {
      //   if (result.value) {
      //     Swal.fire({
      //       title: '请选择题目数',
      //       text: ``,
      //       icon: 'info',
      //       showCancelButton: true,
      //       confirmButtonColor: '#3085d6',
      //       cancelButtonColor: '#d33',
      //       confirmButtonText: '60道题',
      //       cancelButtonText: '120道题',
      //     }).then((result) => {
      //       if (result.value) {
      //         window.open(`http://my3.pzacademy.com:8000/entry/${this.courseId}/2`, '_blank');
      //       } else {
      //         window.open(`http://my3.pzacademy.com:8000/entry/${this.courseId}/1`, '_blank');
      //       }
      //     });
      //   }
      // });
    },
  },
};
